<script>
  import { quintOut, quintIn } from "svelte/easing";
  import { fade, draw, scale } from "svelte/transition";

  export let uniqueIndex;
  export let name = "";
  export let className = "";
  export let r;
  export let translateVal;
  export let trip;
  export let colorBy = "region";
  export let focusPath = null;
  export let leader;
  export let isMobile;

  const checkFocusPath = (uniqueIndex, bool) => {
    if (!focusPath) return;
    focusPath(uniqueIndex, bool);
  };

  // values for animation in leader order
  const delays = {
    "Xi Jinping": 1000,
    "Li Keqiang": 1800,
    "Yang Jiechi": 2600,
    "Wang Yi": 3400,
    Others: 4200,
  };
</script>

<circle
  id={`${name}-${uniqueIndex}`}
  class={"bubble " + className}
  cx="0"
  cy="0"
  {r}
  stroke="#303f46"
  fill="url(#striped-bubble)"
  transform="translate({translateVal})"
  data-color={colorBy === "region"
    ? `region-${trip.data.region}`
    : `income-${trip.data.income_level}`}
  data-region={trip.data.region}
  data-income={trip.data.income_level}
  data-total={trip.data.total}
  data-country={trip.data.country}
  on:mouseenter={() => checkFocusPath(uniqueIndex, true)}
  on:mouseleave={() => checkFocusPath(uniqueIndex, false)}
  in:fade={isMobile === false
    ? {
        duration: 1500,
        delay: delays[leader],
        easing: quintOut,
      }
    : { duration: 0, delay: 0 }}
/>
